import { useEffect, useState } from 'react'
import useSWR from 'swr'

import List from '../ui/list'
import { getRobots } from '../../api'
import { formatFireTime, relativePhrase } from './nextRun'

import './styles.scss'

const LatestLogs = ({ lines }: { lines: string[] }) => (
  <details className='robot-logs'>
    <summary>Latest logs</summary>
    {lines.length > 0 && <pre>{lines.join('\n')}</pre>}
  </details>
)

const useNow = (ticking: boolean) => {
  const [now, setNow] = useState(() => new Date())
  useEffect(() => {
    if (!ticking) return undefined
    const id = window.setInterval(() => setNow(new Date()), 1000)
    return () => window.clearInterval(id)
  }, [ticking])
  return now
}

const NextRun = ({ at, now }: { at: string, now: Date }) => (
  <div className='next-run'>
    <div>{relativePhrase(new Date(at), now)}</div>
    <div>{formatFireTime(at)}</div>
  </div>
)

const RobotsList = () => {
  const { data, isLoading } = useSWR('/api/admin/robots', getRobots)
  const now = useNow(Boolean(data?.some((robot) => robot.nextRun)))

  if (isLoading) return <div>Loading...</div>
  if (!data) return <p>Could not load robots.</p>

  const headers = [
    { label: 'Robot' },
    { label: 'State' },
    { label: 'Last run' },
    { label: 'Next run' },
    { label: 'Latest logs' },
  ]
  const rows = data.map((robot) => [
    robot.name,
    robot.state,
    robot.lastRun,
    robot.nextRun ? <NextRun key={robot.name} at={robot.nextRun} now={now} /> : null,
    <LatestLogs key={robot.name} lines={robot.latestLogs ?? []} />,
  ])

  return <List headers={headers} rows={rows} />
}

export default RobotsList
